// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__rI6VC","spin":"Loader_spin__5KYmJ"};